<template>
  <div class="SoundSetting">
    <br />
    <br />
    <el-row>
      <el-col :span="3" style="text-align: left"> {{ $t("langcfg.txtVolume") }}: </el-col>
      <el-col :span="6">
        <el-slider
          :show-tooltip="false"
          v-model="audio.value"
          input-size="mini"
          :min="0"
          :max="100"
          @change="sliderChanged"
        ></el-slider>
      </el-col>
      <el-col :span="3"
        ><div>{{ audio.value }} %</div></el-col
      >
      <el-col :span="10"
        ><div>
          <div style="display: flex; align-items: center" @click="muteSound">
            <input type="checkbox" class="input-mute" :checked="audio.mute === 1" />
            &nbsp; &nbsp;<span>{{ `${$t(`langcfg.txtMute`)}` }}</span>
          </div>
        </div></el-col
      >
    </el-row>
    <br />
  </div>
</template>
<script>
import fileSys from "../../../fileoprators/fileSystem";
import { saveSettings } from "../../../settings";
import { logStdout, objectCopy } from "../../../shared/utils";
const defaultAudio = {
  value: 0,
  mute: 1
};
let _timeout;
export default {
  data() {
    return {
      audio: {
        value: 0,
        mute: 1
      }
    };
  },
  created() {
    this.audio = window.settings.audio;
  },
  methods: {
    muteSound() {
      this.audio.mute = this.audio.mute === 1 ? 0 : 1;
      window.settings.audio.mute = this.audio.mute;
      saveSettings(window.settings);
      fileSys.muteSound(this.audio.mute);
    },
    sliderChanged(evt) {
      logStdout("set sound value", evt);
      window.settings.audio.value = evt;
      saveSettings(window.settings);
      clearTimeout(_timeout);
      _timeout = setTimeout(() => {
        fileSys.setSound(evt, () => {
          if (evt !== 0) {
            fileSys.playTTS(fileSys.getAudioPath("set-sound-finish.wav"));
          }
        });
      }, 800);
    },
    resetSound() {
      this.audio = objectCopy(defaultAudio);
      window.settings.audio = this.audio;
      saveSettings(window.settings);
      this.sliderChanged(this.audio.value);
    }
  }
};
</script>
<style scoped lang="less">
.SoundSetting {
  margin-left: 40px;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: 45px;
  font-size: 23px;
  width: 150px;
}
.input-mute {
  padding: 0px;
  border: none;
  width: 35px;
  height: 35px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/SoundSetting.vue